import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export function SubmitButton({
	hasValidationErrors,
	loading,
}: {
	hasValidationErrors: boolean;
	loading: boolean;
}): JSX.Element {
	return (
		<Button
			type="submit"
			data-testid="submit"
			data-qa="submit"
			disabled={hasValidationErrors || loading}
			className="w-full md:w-[149px]"
			variant="primary"
			size="small"
		>
			<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.submit_button" />
		</Button>
	);
}
